import { EKwikUIProgressBarSize } from "./progress-bar.definitions";

export const DEFAULT_VALUES = {
  color: "var(--tui-primary)",
  id: "progress_bar",
  isShowLabel: true,
  max: 2,
  size: EKwikUIProgressBarSize.M,
  value: 1
};

export const VALIDATE_KEY_VALUES = {
  color: true,
  isShowLabel: true,
  max: true,
  size: true,
  value: true
};
